module.exports = __webpack_public_path__ + "static/media/testimony3.748ae82f.jpg";